import React, { useState, useEffect, useRef } from 'react';
import { TextField, InputAdornment, IconButton, CircularProgress } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';


const SearchInput = ({
    onSearch,
    onClear,
    debounceMs = 800,
    placeholder = 'Search...',
    sx = {},
    initialValue = '',
}) => {
    const [searchQuery, setSearchQuery] = useState(initialValue);
    const [isSearching, setIsSearching] = useState(false);
    const isMounted = useRef(false);

    useEffect(() => {
        // Skip the initial mount call — the parent dashboard triggers its own
        // initial fetch via its own useEffect. Without this guard, remounting
        // SearchInput (e.g. after a loading spinner replaces the dashboard)
        // fires onSearch('') which resets page back to 0.
        if (!isMounted.current) {
            isMounted.current = true;
            return;
        }
        setIsSearching(true);
        const handler = setTimeout(() => {
            onSearch(searchQuery);
            setIsSearching(false);
        }, debounceMs);

        return () => clearTimeout(handler);
    }, [searchQuery, debounceMs]);

    const handleClear = () => {
        setSearchQuery('');
        onSearch('');
        if (onClear) onClear();
    };

    return (
        <TextField
            size="small"
            placeholder={placeholder}
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        {isSearching
                            ? <CircularProgress size={16} thickness={5} />
                            : <SearchIcon fontSize="small" />
                        }
                    </InputAdornment>
                ),
                endAdornment: searchQuery && (
                    <InputAdornment position="end">
                        <IconButton onClick={handleClear} size="small">
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            sx={{ minWidth: 260, ...sx }}
        />
    );
};

export default SearchInput;